<template>
	<div class='container'>
		<div class="content">

			<div
				class="modal-close-x"
				@click="$router.replace('/wv-login')"
				v-html="`x`"
				v-if="$mq.isWV()"
			/>

			<section
				name='request'
				v-if="!loading"
			>
				<h2>Recupero dei dati</h2>
				<p>Inserisci il tuo indirizzo e-mail, riceverai le istruzioni per reimpostare la password</p>
				<div class="form flex">
					<input type='email' class="form-control" name='email' v-model='email'>
					<CTA
						:content="`Richiedi`"
						@click="request"
						:size="`small`"
						:color="`dark`"
					/>
				</div>

				<flash
		            :flash="flash"
		            :state="state"
		        />
			</section>

			<loading-spin
				v-if="loading"
				:height='400'
			/>

		</div>
	</div>
</template>

<script>

import { UserApi } from '../api/UserApi'

import { container } from '../services/container'
import { User } from '../core/User'

import Flash from './Parts/Flash'
import CTA from './Elements/CTA'
export default {
	data () {
		return {
			email: null,
			flash: null,
			state: null,

			loading: false
		}
	},

	components: {
		CTA,
		Flash
	},

	methods: {
		request () {
			this.flash = null
			var um = new UserApi()
			um.signInEmail(this.email).then(response => {
				this.state = 'success'
				this.flash = "Riceverai un'email contenente le istruzioni per il recupero della password nei prossimi minuti"
			}).catch(response => {
				this.state = 'error'
				this.flash = response.body.message
			})
		}
	},

	mounted () {
		var authToken = container.get('services.cookies').get('auth_token', '/')
		if (!authToken) return

		this.loading = true
		
		container.get('services.cookies').remove('auth_token')

		container.get('services.oauth').signInAuthToken(authToken).then(response => {
			return container.get('services.oauth').authenticate()
		}).then(response => {
			this.$root.updateUser(new User(response.body.data.resource))
			this.$router.push('/user/profile/password')
		}).catch(response => {
			if (response && response.body && response.body.message) {
				var errorMessage = response.body.message
				this.flash = this.$t('api.' + errorMessage.toLowerCase().replace(/\s+/g, '_'))
				this.state = 'error'

				var err = 'Failed sign in with auth token ' + authToken + '. Error: ' + errorMessage

				if (typeof bugsnagClient !== 'undefined') bugsnagClient.notify(new Error(err))
			}

			this.loading = false
		})
	}
}

</script>

<style scoped>


section {
	max-width: 800px;
	margin: 0 auto;
}

.flash {
	margin: 10px 0;
}

.flash.error {
	color: red;
}

@media (max-width: 1024px) {
}
</style>
